import { memo } from 'react';
const OutlineText = memo(function OutlineText({ styles, text, className }) {
    return <>
        <div className={`${styles.text} ${className}`}>{text}
            <div className={styles.face}>{text} </div>
        </div>
    </>
});

export default OutlineText;